import { HelperOptions } from 'handlebars';

import { BaseObject } from '@gss/types/shared';

const object = (options: HelperOptions): BaseObject => {
  return options?.hash as BaseObject;
};

export default object;
